import { parseISO } from 'date-fns';

import { FeedbackRequestApiData } from '../../types/feedback';

export interface FeedbackRequestData {
	id: string;
	expiresAt: string | null;
	requestedAt: string | null;
	text: string;
}

export class FeedbackRequest {
	id: string;
	expiresAt: Date | null;
	requestedAt: Date | null;
	text: string;

	constructor(data: FeedbackRequestData) {
		this.id = data.id;
		this.expiresAt = data.expiresAt ? parseISO(data.expiresAt) : null;
		this.requestedAt = data.requestedAt ? parseISO(data.requestedAt) : null;
		this.text = data.text;
	}

	public static fromApiData(request: FeedbackRequestApiData) {
		return new FeedbackRequest({
			id: request.id,
			expiresAt: request.expires_at,
			requestedAt: request.requested_at,
			text: request.text,
		});
	}
}
